import { render, staticRenderFns } from "./MonthlyComparisonCard.vue?vue&type=template&id=27f1d33e&scoped=true&"
import script from "./MonthlyComparisonCard.vue?vue&type=script&lang=js&"
export * from "./MonthlyComparisonCard.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyComparisonCard.vue?vue&type=style&index=0&id=27f1d33e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1d33e",
  null
  
)

export default component.exports